import React, {useState} from 'react';
import classNames from "classnames";
import {SpinLoader} from "./Loader";
import _ from "lodash";
import createLink from "../../libs/createLink";
import { Link } from "react-router-dom";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {fetchOffers, fetchOfferFormData, OFFERS} from "../../api/public-voissa/offers";
import {fetchCurrentUserAbo, USER_CURRENT_KEY} from "../../api/public-voissa/users";
import {useBreakpoint} from "../../libs/breakpoint";


let advantages = [
    "Chat illimité avec tous les membres",
    "Accès au chat webcam",
    //"Publier et consulter les annonces de rencontre",
    "Faire des demandes d'amitié"
];

const maxRetry = 10;

const ModalSubscription = ({
                               handleClose = () =>{},
                               className = "",
                               isArchived = false
                           }) =>{
    const queryClient = useQueryClient();

    const [step, setStep] = useState(1);
    const [selectedBiller, setSelectedBiller] = useState("");
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [refetchInterval, setRefetchInterval] = useState(0);
    const [refetchIntervalCount, setRefetchIntervalCount] = useState(0);


    let popupInterval = null;

    const breakpoints = useBreakpoint();

    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);

    if(_.get(dataCurrentUser, 'abTestings[0]')){
        isArchived = dataCurrentUser.abTestings.filter(item => item._id === "647858afde31e8e3e511321a") ? true : isArchived;
    }

    let stepsComponents = [
        _renderStepOne,
        _renderStepTwo,
        _renderStepThree,
        _renderStepFour,
        _renderStepFive
    ];

    const {isSuccess : isSuccessOffers ,data : dataOffers, isFetched : isFetchedOffers} = useQuery(
        [OFFERS],
        ()=> fetchOffers(),
        {
            staleTime : (1000 * 60 * 5),
            placeholderData : [],
            select : (data) =>data.data || []
        }
    );

    let offers = dataOffers || [];

    const {data : dataUserAbo, isError : isErrorUserAbo} = useQuery(
        ['USER_ABO'],
        ()=> fetchCurrentUserAbo(),
        {
            staleTime : 3000,
            refetchOnWindowFocus : true,
            refetchInterval : refetchInterval,
            onSuccess : async () =>{
                await fetchAbo();
            }
        }
    );

    const {
        mutate : mutateFormOffer,
        isLoading : isLoadingFormOffer
    } = useMutation(offerId => fetchOfferFormData(offerId),{
        onSuccess: (data) =>{
            if(data?.urlForm){
                if(data?.type === "form"){
                    _submitForm(data);
                }
                else{
                    let isMobile = breakpoints.md;
                    if(!isMobile){
                        let left = (window.screen.width / 2) - (600 / 2);
                        let top = (window.screen.height / 2) - (780 / 2);
                        let popup = window.open('', 'formVoissa', 'toolbar=0,location=0,directories=0,status=1,menubar=0,scrollbars=1,resizable=1,width=600,height=780,top=' + top + ',left=' + left);
                        popupInterval = setInterval(()=>{
                            if(popup.closed){
                                clearInterval(popupInterval);
                                //nextStep();
                                setStep(step + 1);
                                setRefetchInterval(3000);
                            }
                        }, 200)
                    }

                    let form = window.document.createElement("form");
                    form.setAttribute("method", "get");
                    form.setAttribute("action", data?.urlForm);
                    if(!isMobile) {
                        form.setAttribute("target", "formVoissa");
                    }

                    window.document.body.appendChild(form);

                    form.submit();

                }

            }
        }
    });


    async function fetchAbo(){
        let checkIsAbo = _.get(dataUserAbo, "abo") || false;
        if(checkIsAbo && step !== 1){
            setStep(5);
            setRefetchInterval(0);
            //await queryClient.invalidateQueries([USER_CURRENT_KEY]);
            window.location.reload();
        }
        else if(checkIsAbo && step === 1){
            setRefetchInterval(0);
            window.location.reload();
            //await queryClient.invalidateQueries([USER_CURRENT_KEY]);
        }
        if(refetchIntervalCount >= maxRetry){
            setRefetchInterval(0);
        }
        setRefetchIntervalCount(refetchIntervalCount + 1);
    }

    function _submitForm(currentOffer) {
        let isMobile = breakpoints.md;
        let popup = null;
        if(!isMobile) {
            let left = (window.screen.width / 2) - (600 / 2);
            let top = (window.screen.height / 2) - (780 / 2);
            popup = window.open('', 'formVoissa', 'toolbar=0,location=0,directories=0,status=1,menubar=0,scrollbars=1,resizable=1,width=600,height=780,top=' + top + ',left=' + left);
        }
        let isAbo = _.get(dataUserAbo, "abo") || false;
        if(isAbo){
            setRefetchInterval(0);
            setStep(1);
            if(popup) {
                popup.close();
            }
        }
        else{
            let form = window.document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", currentOffer.urlForm);
            if(!isMobile) {
                form.setAttribute("target", "formVoissa");
            }

            let data = currentOffer.data || {};
            Object.keys(data).forEach(key =>{
                let inputIds = window.document.createElement('input');
                inputIds.type = 'hidden';
                inputIds.name = key;
                inputIds.value = data[key];
                form.appendChild(inputIds);
            })


            window.document.body.appendChild(form);

            form.submit();
            if(!isMobile) {
                popupInterval = setInterval(() => {
                    if (popup.closed) {
                        clearInterval(popupInterval);
                        //nextStep();
                        setStep(step + 1);
                        setRefetchInterval(3000);
                        if (form && window.document?.body?.removeChild) {
                            window.document.body.removeChild(form);
                        }
                    }
                }, 200)
            }
        }
    }


    function _handleSelectOffer(_id) {
        setSelectedOffer(_id);
    }

    function _handleSubmit() {
        mutateFormOffer(selectedOffer._id);
    }
    


    function _renderStepOne() {
       return isSuccessOffers && !offers.length ? (
            <div id="msub-step3">
                <div className="msub-title">
                    Votre accès <span>Premium</span>
                </div>
                {!isFetchedOffers ? (
                    <SpinLoader />
                ) : (
                    <p>Nous vous prions de nous excuser, mais aucune offre d'abonnement n'est disponible actuellement.</p>
                )}

                <div
                    className="msub-button-step activated mt-8"
                    onClick={()=>handleClose()}
                >
                    Fermer
                </div>
            </div>
        ) : (
            <div id="msub-step1">
                <div className="msub-title">
                    Votre accès <span>Premium</span>
                </div>
                <ul className="msub-advantages">
                    {isArchived ? <li>Accès aux vidéos de plus de 30 jours</li> : null}
                    {advantages.map((advantage, index) => (<li key={`advantage_${index}`}>{advantage}</li>))}
                </ul>

                <div
                    className={"msub-button-step activated"}
                    onClick={() => setStep(2)}
                >
                    Continuer
                </div>
                <div className="msub-footer-text">Paiement sécurisé - Anonymat garanti</div>
            </div>
        )
    }

    function _renderStepTwo() {
        const uniqueProcesseurs = isSuccessOffers && offers.length ? [...new Set(offers.map(item => item.processeur))] : [];
        return (
            <div id="msub-step1">
                <div className="msub-title">
                    Plusieurs options de <span>paiement</span>
                </div>
                <ul className="msub-advantages">
                    <li>Voissa ne propose pas de paiement en son nom.</li>
                    <li>Choisissez un partenaire externe</li>
                    <li><a href={createLink("contact")} target={"_blank"} rel="noreferrer">Contactez-nous</a> en cas de question</li>
                </ul>
                <div className="msub-offers-grid">
                    {uniqueProcesseurs.map(biller => (
                        <div key={biller} className="msub-offer-col" onClick={() => setSelectedBiller(biller)}>
                            {biller === "neosurf" ? (
                                <div
                                    className={classNames("msub-offer", {active: biller === selectedBiller})}>
                                    <div className="msub-offer-price">
                                        Neosurf
                                    </div>

                                    <div className="msub-offer-subone">
                                        Paiement anonyme avec un code.
                                    </div>

                                </div>
                            ) : null}
                            {biller === "vendo" ? (
                                <div
                                    className={classNames("msub-offer", {active: biller === selectedBiller})}>
                                    <div className="msub-offer-price">
                                        Vendo
                                    </div>

                                    <div className="msub-offer-subone">
                                        Paiement SEPA ou crypto.
                                    </div>

                                </div>
                            ) : null}
                            {biller === "mobiyo" ? (
                                <div
                                    className={classNames("msub-offer", {active: biller === selectedBiller})}>
                                    <div className="msub-offer-price">
                                        Mobiyo
                                    </div>

                                    <div className="msub-offer-subone">
                                        Abonnement par carte bancaire.
                                    </div>

                                </div>
                            ) : null}
                            {biller === "monerchy" ? (
                                <div
                                    className={classNames("msub-offer", {active: biller === selectedBiller})}>
                                    <div className="msub-offer-price">
                                        Monerchy
                                    </div>

                                    <div className="msub-offer-subone">
                                        Paiement sécurisé de banque à banque.
                                    </div>

                                </div>
                            ) : null}
                        </div>
                    ))}
                </div>
                <div
                    className={classNames("msub-button-step", {activated: !!selectedBiller})}
                    onClick={() => !!selectedBiller && setStep(3)}
                >
                    {!!selectedBiller ? "Continuer" : "Sélectionnez un partenaire"}
                </div>
                <div className="msub-footer-text">Paiement sécurisé - Anonymat garanti</div>
            </div>
        )
    }

    function _renderStepThree() {

        let title = {
            vendo : "Paiement avec Vendo",
            neosurf : "Paiement avec Neosurf",
            mobiyo : "Paiement avec Mobiyo",
            monerchy : "Paiement avec Monerchy"
        }

        let offersList = offers.filter(item => item.processeur === selectedBiller );

        if(!selectedOffer && offersList.length){
            setSelectedOffer(offersList[0]);
        }

        return(
            <div id="msub-step3">
                <div className="msub-title">
                    {title[selectedBiller] || "Paiement"}
                </div>
                {selectedBiller === "neosurf" && selectedOffer  ? (
                    <ul className="msub-advantages">
                        <li>Aucun renouvellement automatique</li>
                        <li>Paiement anonyme</li>
                    </ul>
                ) : null}
                {selectedBiller === "vendo" && selectedOffer  ? (
                    <ul className="msub-advantages">
                        <li>Plusieurs modes de paiement disponible</li>
                        <li>Paiement sécurisé</li>
                    </ul>
                ) : null}
                {selectedBiller === "mobiyo" && selectedOffer  ? (
                    <ul className="msub-advantages">
                        <li>Résiliez à tout moment</li>
                        <li>Support réactif</li>
                        <li>Anonymat garanti</li>
                        <li>Paiement sécurisé</li>
                    </ul>
                ) : null}
                {selectedBiller === "monerchy" && selectedOffer  ? (
                    <ul className="msub-advantages">
                        <li>Une solution Open banking</li>
                        <li>Paiement sécurisé sans carte bancaire</li>
                    </ul>
                ) : null}
                <div className="msub-offers-grid">
                    {offersList.map(offer => (
                        <div key={offer._id} className="msub-offer-col" onClick={() => _handleSelectOffer(offer)}>
                            <div
                                className={classNames("msub-offer", {active: offer._id === _.get(selectedOffer, "_id")})}>
                                <div className="msub-offer-title">
                                    {offer.name}
                                </div>
                                <div className="msub-offer-price">
                                    {offer.price_abo}<span>€</span>
                                </div>
                                <div className="msub-offer-subone">
                                    {offer.advantage1}
                                </div>
                                <div className="msub-offer-subtwo">
                                    {offer.advantage2}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {selectedBiller === "neosurf" && selectedOffer  ? (
                    <div className="msub-pay-infos">
                        <p>Le paiement sera effectué en dehors de Voissa : soit en espèces dans un magasin, soit en ligne avec la création d'un compte MyNeosurf.</p>
                        <p>Des revendeurs en ligne proposent d'acheter le code avec paiement d'une commission supplémentaire.</p>
                        <p>Prestataire : VA MEDIA - 10 rue du Colisée 75008.</p>
                    </div>
                ) : null}


                {selectedBiller === "vendo" && selectedOffer  ? (
                    <div className="msub-pay-infos">
                        <p>Votre paiement fera apparaitre la mention <strong>VendoStore*VAMedia</strong> sur votre relevé bancaire. Voissa ne sera pas mentionné.</p>
                        <p>Vous paierez {selectedOffer?.price_abo} euros pour {selectedOffer?.nb_jours_abo || 0} jours. Reconduction de l’abonnement tous les {selectedOffer?.nb_jours_abo || 0} jours.</p>
                        <p>Prestataire : VA MEDIA - 10 rue du Colisée 75008.</p>
                    </div>
                ) : null}


                {selectedBiller === "mobiyo" && selectedOffer ? (
                    <div className="msub-pay-infos">
                        <p>Votre paiement fera apparaitre la mention VA MEDIA sur votre relevé bancaire.</p>
                        <p>Vous paierez {selectedOffer?.price_abo} euro
                            pour {selectedOffer?.nb_jours_abo || 0} jours.
                            Reconduction de l’abonnement tous
                            les {selectedOffer?.nb_jours_abo || 0} jours.</p>
                        <p>Prestataire : VA MEDIA - 10 rue du Colisée 75008.</p>
                    </div>
                ) : null}

                {selectedBiller === "monerchy" && selectedOffer  ? (
                    <div className="msub-pay-infos">
                        <p>Vous paierez {selectedOffer?.price_abo || 0} euros pour {selectedOffer?.nb_jours_abo || 0} jours. Aucun renouvellement automatique.</p>
                        <p>Prestataire : VA MEDIA - 10 rue du Colisée 75008.</p>
                    </div>
                ) : null}

                <div
                    className={"msub-link-goback"}
                    onClick={() => {
                        setStep(2);
                        setSelectedOffer(null);
                    }}
                >
                    Retour
                </div>

                <div
                    className={classNames("msub-button-step", {activated: !!selectedOffer})}
                    onClick={() => !!selectedOffer && !isLoadingFormOffer && _handleSubmit()}
                >
                    {!!selectedOffer ? "Payer" : "Sélectionnez une offre"}
                    {isLoadingFormOffer ? <SpinLoader /> : null}
                </div>

            </div>
        );
    }
    
    function _renderStepFour() {
        return (
            <div id="msub-step3">
                <div className="msub-title">
                    <SpinLoader className={"small"}/>
                </div>
                <div className="msub-title">
                    Nous vérifions votre paiement...
                </div>
            </div>
        )
    }

    function _renderStepFive() {
        return (
            <div id="msub-step3">
                <div className="msub-title">
                    Votre accès <span>Premium</span>
                </div>
                <p>Nous avons le plaisir de vous confirmer votre accès Premium.</p>
                <div
                    className="msub-button-step activated mt-8"
                    onClick={()=>handleClose()}
                >
                    Fermer
                </div>
            </div>
        )
    }

    function _isAbonned() {
        return (
            <div id="msub-step3">
                <div className="msub-title">
                    Votre accès <span>Premium</span>
                </div>
                <p>Vous êtes déjà abonné.</p>
                <div
                    className="msub-button-step activated mt-8"
                    onClick={()=>handleClose()}
                >
                    Fermer
                </div>
            </div>
        )
    }

    function _isError() {
        return (
            <div id="msub-step3">
                <div className="msub-title">
                    Votre accès <span>Premium</span>
                </div>
                <p>Nous avons rencontré un problème durant le paiement, Merci de <Link to={createLink("contact")}>contacter</Link> notre équipe</p>
                <div
                    className="msub-button-step activated mt-8"
                    onClick={()=>handleClose()}
                >
                    Fermer
                </div>
            </div>
        )
    }


    return (
        <div id="ModalSubscription" className={className}>
            {_.get(dataUserAbo,'abo') && step === 1  && !isErrorUserAbo
                ? ( _isAbonned() )
                : (isErrorUserAbo || refetchIntervalCount > maxRetry) ? (_isError()) : (stepsComponents[step - 1]())
            }
        </div>
    )
};

export default ModalSubscription;